/**
 * Voice engine factory used by the app: the WebRTC mesh (engine.ts) on the browser's media
 * APIs (browserMedia.ts). Where WebRTC or the microphone are missing (old browsers, a page
 * that is not HTTPS, Node in tests) it still works as far as it can: listening without a
 * microphone, or only the state the UI shows.
 */
import { createBrowserVoiceMedia } from './browserMedia';
import { VoiceEngine } from './engine';
import type { VoiceControllerFactory } from './types';

export const createVoiceController: VoiceControllerFactory = (deps) =>
  new VoiceEngine(deps, createBrowserVoiceMedia());
